import { combineReducers } from 'redux';
import { atRetirement } from './atRetirement';
import { raOptimal } from './raOptimal';
import { covidSelfAssessment } from './covidSelfAssessment';
import { incomeTaxCalculator } from './incomeTaxCalculator';
import { easiplusFuneralPlan } from './easiplusFuneralPlan';
import { publicWeb } from './publicWeb';
import { pastPerformanceCalculator } from './pastPerformanceCalculator/pastPerformanceCalculator';
import { personalLoansCalculator } from './personalLoansCalculator';
import { namPersonalLoansCalculator } from './namPersonalLoansCalculator';
import { savingsCalculators } from './savingsCalculator';
import { customerVerificationService } from './customerVerificationService';
import { fundCentre } from './fundCentre';
import { priceTable } from './priceTable';
import { taxFreeSavingsAccount } from './taxFreeSavingsAccount';
import { roaQuoteTools } from './roaQuoteTools';
import { retirementCalculator } from './retirementCalculator';
import { customerComplaint } from './customerComplaint';
import { budgetBenchmarkCalculator } from './budgetBenchmarkCalculator';
import { educationCalculator } from './educationCalculator';
import { roaCarInsurance } from './roaCarInsurance';
import { debtRepaymentCalculator } from './debtRepaymentCalculator';
import { roaTravelInsurance } from './roaTravelInsurance';
import { investmentCalculators } from './investmentCalculator';
import { fundDeclarations } from './fundDeclarations';
import { customerSatisfactionSurvey } from './customerSatisfactionSurvey';
import { ltd } from './ltd';
import makeAClaim from './makeAClaim';
import { financialEducation } from './financialEducation';
import { quizAssessment } from './quizAssessment';
import { digitalOnboarding } from './digitalOnboarding';
import { ugMotorInsurance } from './ugMotorInsurance';
import { naMotorInsurance } from './naMotorInsurance';
import { personalAccident } from './personalAccident';
import { domesticInsurance } from './domesticInsurance';
import { biasharaFlexi } from './biasharaFlexi';
import { travel } from './travel';
import { digiLifeLoanProtection } from './digiLifeLoanProtection';
import { doctorsPi } from './doctorsPi';
import { afyaImara } from './afyaImara';
import { motorPrivateRW } from './motorPrivateRW';
import { personalPensionPlan } from './personalPensionPlan';
import { allsureInsurance } from './allsureInsurance';
import { savingsPotCalculator } from './savingsPotCalculator';
import { sizotsaFuneralCover } from './sizotsaFuneralCover'
import {sizotsaFuneralClaim} from "./sizotsaFuneralClaim"
import { travelUg } from './travelUg';
import { travelSs } from './travelSs';
import { digitalSavings } from './digitalSavings';
import { healthInsuranceRwanda } from './healthInsuranceRW';
import { travelKe } from './travelKe';
import { kaMetlhaFuneralCover } from './kaMetlhaFuneralCover'
import {kaMetlhaFuneralClaim}from './kaMetlhaFuneralClaim'
import { eaTravelRates } from './eaTravelRates';
import { fauluLoanCalculatorStore } from './fauluLoanCalculator'
import { allsureHomeClaim } from './allsureHomeClaim';
import { allSureMotorClaim } from './allSureMotorClaim';

export const rootReducer = combineReducers({
    atRetirement,
    raOptimal,
    covidSelfAssessment,
    incomeTaxCalculator,
    easiplusFuneralPlan,
    publicWeb,
    fundCentre,
    pastPerformanceCalculator,
    personalLoansCalculator,
    namPersonalLoansCalculator,
    savingsCalculators,
    customerVerificationService,
    roaQuoteTools,
    retirementCalculator,
    taxFreeSavingsAccount,
    priceTable,
    customerComplaint,
    budgetBenchmarkCalculator,
    educationCalculator,
    roaCarInsurance,
    debtRepaymentCalculator,
    roaTravelInsurance,
    investmentCalculators,
    fundDeclarations,
    customerSatisfactionSurvey,
    ltd,
    makeAClaim,
    financialEducation,
    quizAssessment,
    digitalOnboarding,
    ugMotorInsurance,
    naMotorInsurance,
    personalAccident,
    domesticInsurance,
    biasharaFlexi,
    travel,
    digiLifeLoanProtection,
    doctorsPi,
    afyaImara,
    motorPrivateRW,
    personalPensionPlan,
    allsureInsurance,
    savingsPotCalculator,
    sizotsaFuneralCover,
    sizotsaFuneralClaim,
    travelUg,
    digitalSavings,
    healthInsuranceRwanda,
    travelKe,
    kaMetlhaFuneralCover,
    kaMetlhaFuneralClaim,
    travelSs,
    eaTravelRates,
    fauluLoanCalculatorStore,
    allsureHomeClaim,
    allSureMotorClaim
});
